"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var DataProviderContext = react_1.createContext(null);
DataProviderContext.displayName = 'DataProviderContext';
exports.default = DataProviderContext;
